<template>
  <FormulateForm
    ref="form"
    name="form"
  >
    <e-sidebar
      id="sidebar-stock-counting-rule"
      :title="isEdit ? $t('Editar Regra de Contagem') : $t('Nova Regra de Contagem')"
      :show="showSidebar"
      :fetching="fetching"
      :saving="saving"
      width="500px"
      @save="onSaveRule"
      @hidden="showSidebar = false"
    >
      <template #content>
        <b-row>
          <b-col md="12">
            <FormulateInput
              id="rule-group-id"
              v-model="ruleForm.groupId"
              :label="$t('Grupo')"
              type="vue-select"
              :placeholder="$t('Selecione')"
              :options="groupOptions"
            />
          </b-col>

          <b-col md="12">
            <FormulateInput
              id="rule-brand-id"
              v-model="ruleForm.brandIds"
              :label="$t('Marcas')"
              type="vue-select"
              :multiple="true"
              :placeholder="$t('Selecione')"
              :options="brandOptions"
            />
          </b-col>

          <b-col md="12">
            <FormulateInput
              id="rule-day-of-week"
              v-model="ruleForm.daysOfWeek"
              type="vue-select"
              :multiple="true"
              :label="$t('Dias da semana')"
              :placeholder="$t('Selecione')"
              :options="stockCountingDayOfWeekOptions()"
              class="required"
              validation="required"
            />
          </b-col>

          <b-col md="12">
            <FormulateInput
              id="rule-min-countings"
              v-model.number="ruleForm.minCountings"
              type="text-number"
              :precision="0"
              :label="$t('Mín. contagens obrigatórias')"
              class="required"
              validation="required|min:1"
            />
          </b-col>

          <b-col md="12">
            <FormulateInput
              id="rule-active"
              v-model="ruleForm.active"
              type="switch"
              :label="$t('Ativo')"
            />
          </b-col>

          <b-col md="12">
            <FormulateInput
              id="rule-description"
              v-model="ruleForm.description"
              type="textarea"
              :label="$t('Descrição')"
            />
          </b-col>
        </b-row>
      </template>
    </e-sidebar>
  </FormulateForm>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import { ESidebar } from '@/views/components'
import { formulateHelper, productDomains, stockDomain } from '@/mixins'
import { mapGetters, mapActions, mapState } from 'vuex'

export default {
  components: { BRow, BCol, ESidebar },

  mixins: [formulateHelper, productDomains, stockDomain],

  data() {
    return {
      showSidebar: false,
      fetching: false,
      saving: false,
    }
  },

  computed: {
    ...mapState('pages/stock/stockCountingRules', ['ruleForm']),
    ...mapGetters('pages/catalog/products', ['getComboBrands', 'getComboGroups']),

    // Normaliza o value das opções para string, garantindo que o vue-select
    // case o valor selecionado (grupo/marcas) e exiba o rótulo corretamente.
    groupOptions() {
      return this.getComboGroups.map(o => ({ ...o, value: o.value != null ? String(o.value) : o.value }))
    },
    brandOptions() {
      return this.getComboBrands.map(o => ({ ...o, value: o.value != null ? String(o.value) : o.value }))
    },

    isEdit() {
      return !!this.ruleForm.id
    },
  },

  watch: {
    showSidebar() {
      this.$refs.form.hideErrors()
    },
  },

  async mounted() {
    this.fetching = true
    try {
      await this.fetchProductCombos()
    } finally {
      this.fetching = false
    }
  },

  methods: {
    ...mapActions('pages/stock/stockCountingRules', ['saveRule']),
    ...mapActions('pages/catalog/products', ['fetchProductCombos']),

    async onSaveRule() {
      this.$refs.form.showErrors()
      if (this.$refs.form.isValid) {
        try {
          this.saving = true
          await this.saveRule()
          this.showSuccess({
            message: this.isEdit
              ? this.$t('Regra atualizada com sucesso')
              : this.$t('Regra criada com sucesso'),
          })
          this.showSidebar = false
          this.$emit('save')
        } catch (error) {
          this.showError({ error, message: this.$t('Não foi possível concluir a operação') })
        } finally {
          this.saving = false
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
